module.exports = __webpack_public_path__ + "static/media/MOLDURA_PES_ISTAMBUL_2023_05-OLIGARK.4574a13f.png";